import { css } from '@emotion/react';
import { darkThemeStyle, theme } from '../theme';
import { tokens } from '../tokens';
// Mapping between text-area sizes
const sizeMap = {
    large: {
        sizing: tokens.sizing.large,
        spacingHorizontal: tokens.spacingNew.medium,
        spacingVertical: tokens.spacingNew.small,
    },
    medium: {
        sizing: tokens.sizing.medium,
        spacingHorizontal: tokens.spacingNew.small,
        spacingVertical: '6px',
    },
    small: {
        sizing: tokens.sizing.small,
        spacingHorizontal: tokens.spacingNew.small,
        spacingVertical: tokens.spacingNew.tiny,
    },
};
const textAreaWrapperStaticStyle = css({
    '&::after': {
        borderRadius: '6px',
        content: '""',
        display: 'block',
        inset: 0,
        margin: '-2px',
        pointerEvents: 'none',
        position: 'absolute',
        transition: 'box-shadow 125ms ease-out',
        zIndex: tokens.zIndex.default,
    },
    position: 'relative',
});
export function textAreaWrapperStyle({ inverted, isFocusVisible, }) {
    return [
        ...(inverted ? [darkThemeStyle] : []),
        textAreaWrapperStaticStyle,
        css(Object.assign({}, (isFocusVisible && {
            '&::after': {
                boxShadow: `0 0 0 2px ${theme.border.focusOutline}`,
            },
        }))),
    ];
}
const textAreaStaticStyle = css({
    '::placeholder': {
        color: theme.text.subtle,
        opacity: 1,
    },
    ':disabled': {
        cursor: 'default',
        opacity: tokens.opacity.medium,
    },
    backgroundColor: theme.background.contrast,
    border: `${tokens.borderWidth.thin} solid ${theme.border.strong}`,
    borderRadius: tokens.borderRadius.medium,
    color: theme.text.main,
    display: 'block',
    fontFamily: tokens.fontFamilies.sansSerif,
    fontWeight: tokens.fontWeights.regular,
    height: '100%',
    lineHeight: tokens.lineHeights.relaxed,
    outline: 0,
    resize: 'none',
    width: '100%',
    wordBreak: 'break-word',
});
export function textAreaStyle({ hasError, size }) {
    return [
        textAreaStaticStyle,
        css(Object.assign({ fontSize: tokens.fontSizes[size], minHeight: sizeMap[size].sizing, padding: `${sizeMap[size].spacingVertical} ${sizeMap[size].spacingHorizontal}` }, (hasError && {
            borderColor: theme.error.darker,
            boxShadow: `0 0 0 1px ${theme.error.darker}`,
        }))),
    ];
}
export const growWrapperStyle = css({
    display: 'grid',
});
const fauxGrowElementStaticStyle = css({
    gridArea: '1 / 1 / 2 / 2',
    visibility: 'hidden',
    whiteSpace: 'pre-wrap',
});
export function fauxGrowElementStyle({ size }) {
    return [
        textAreaStaticStyle,
        fauxGrowElementStaticStyle,
        css({
            fontSize: tokens.fontSizes[size],
            padding: `${sizeMap[size].spacingVertical} ${sizeMap[size].spacingHorizontal}`,
        }),
    ];
}
export const characterCountStaticStyle = css({
    alignItems: 'center',
    bottom: tokens.spacingNew.xsmall,
    color: theme.text.subtle,
    display: 'flex',
    lineHeight: tokens.lineHeights.default,
    pointerEvents: 'none',
    position: 'absolute',
    right: tokens.spacingNew.small,
    zIndex: tokens.zIndex.default,
});
